export const SHORT_NAME_NOT_EXIST_HELPER_TEXT = 'Short name already exist in other service Type';
export const TARGET_OPTION_CANNOT_EMPTY_HELPER_TEXT = 'Select at least one target option';